import t from "../../theme";

/* ─── SVG doodle pattern: business-themed icons ─── */
const businessPatternSvg =
  encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="300" height="300" viewBox="0 0 300 300">
  <g fill="none" stroke="rgba(255,255,255,0.09)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">

    <!-- storefront -->
    <g transform="translate(15,20) rotate(-8)">
      <rect x="0" y="10" width="26" height="16" rx="2"/>
      <path d="M-2,10 L13,0 L28,10"/>
      <line x1="10" y1="18" x2="10" y2="26"/>
      <line x1="16" y1="18" x2="16" y2="26"/>
      <rect x="10" y="18" width="6" height="8"/>
    </g>

    <!-- briefcase -->
    <g transform="translate(230,15) rotate(10)">
      <rect x="0" y="6" width="24" height="16" rx="3"/>
      <path d="M7,6 L7,3 Q7,0 10,0 L14,0 Q17,0 17,3 L17,6"/>
      <line x1="0" y1="14" x2="24" y2="14" stroke-width="2"/>
    </g>

    <!-- bar chart -->
    <g transform="translate(40,80) rotate(5)">
      <line x1="0" y1="22" x2="22" y2="22"/>
      <rect x="2" y="12" width="4" height="10" rx="1"/>
      <rect x="9" y="6" width="4" height="16" rx="1"/>
      <rect x="16" y="2" width="4" height="20" rx="1"/>
    </g>

    <!-- handshake -->
    <g transform="translate(135,30) rotate(-6)">
      <path d="M0,12 Q4,8 8,8 L14,8 Q18,8 22,12" stroke-width="2.2"/>
      <path d="M8,8 Q11,4 14,8"/>
      <path d="M-2,14 Q0,10 4,10"/>
      <path d="M24,14 Q22,10 18,10"/>
    </g>

    <!-- dollar sign -->
    <g transform="translate(265,75) rotate(12)">
      <circle cx="10" cy="10" r="10"/>
      <path d="M10,4 C7,4 7,8 10,8 C13,8 13,12 10,12 Q7,12 7,10" stroke-width="2.2"/>
      <line x1="10" y1="2" x2="10" y2="4"/>
      <line x1="10" y1="12" x2="10" y2="14"/>
    </g>

    <!-- pie chart -->
    <g transform="translate(140,95) rotate(-10)">
      <circle cx="10" cy="10" r="10"/>
      <path d="M10,10 L10,0"/>
      <path d="M10,10 L18,16"/>
    </g>

    <!-- megaphone / marketing -->
    <g transform="translate(10,155) rotate(8)">
      <path d="M0,10 Q2,4 6,2 L20,8 Q20,14 20,16 L6,22 Q2,20 0,14 Z" stroke-width="2.2"/>
      <path d="M20,10 Q24,10 24,13 Q24,16 20,16"/>
    </g>

    <!-- target / bullseye -->
    <g transform="translate(70,240) rotate(-5)">
      <circle cx="10" cy="10" r="10"/>
      <circle cx="10" cy="10" r="6"/>
      <circle cx="10" cy="10" r="2"/>
    </g>

    <!-- lightbulb (idea) -->
    <g transform="translate(220,150) rotate(-12)">
      <path d="M10,0 Q20,0 20,10 Q20,16 14,18 L6,18 Q0,16 0,10 Q0,0 10,0 Z"/>
      <line x1="6" y1="18" x2="6" y2="22"/>
      <line x1="14" y1="18" x2="14" y2="22"/>
      <path d="M6,22 Q10,24 14,22"/>
      <line x1="10" y1="10" x2="10" y2="14" stroke-width="2"/>
    </g>

    <!-- gear / settings -->
    <g transform="translate(85,15) rotate(15)">
      <circle cx="10" cy="10" r="5"/>
      <path d="M10,0 L10,3 M10,17 L10,20 M0,10 L3,10 M17,10 L20,10 M3,3 L5,5 M15,15 L17,17 M17,3 L15,5 M5,15 L3,17" stroke-width="2.2"/>
    </g>

    <!-- envelope / email -->
    <g transform="translate(155,255) rotate(10)">
      <rect x="0" y="0" width="22" height="15" rx="3"/>
      <path d="M0,0 Q11,12 22,0"/>
    </g>

    <!-- trophy -->
    <g transform="translate(270,200) rotate(-8)">
      <path d="M4,0 Q4,14 12,16 Q20,14 20,0 Z" stroke-width="2.2"/>
      <path d="M4,4 Q-2,4 -2,8 Q-2,12 4,12"/>
      <path d="M20,4 Q26,4 26,8 Q26,12 20,12"/>
      <line x1="12" y1="16" x2="12" y2="22"/>
      <path d="M6,22 Q12,24 18,22"/>
    </g>

    <!-- globe / world -->
    <g transform="translate(200,42) rotate(6)">
      <circle cx="10" cy="10" r="10"/>
      <ellipse cx="10" cy="10" rx="5" ry="10"/>
      <line x1="0" y1="10" x2="20" y2="10"/>
    </g>

    <!-- rocket -->
    <g transform="translate(100,190) rotate(-15)">
      <path d="M10,0 Q16,4 16,12 L12,18 L8,18 L4,12 Q4,4 10,0 Z" stroke-width="2.2"/>
      <circle cx="10" cy="8" r="2"/>
      <path d="M4,12 L0,14 L4,16"/>
      <path d="M16,12 L20,14 L16,16"/>
    </g>

    <!-- shield / security -->
    <g transform="translate(250,265) rotate(5)">
      <path d="M10,0 L20,4 L20,12 Q20,20 10,24 Q0,20 0,12 L0,4 Z"/>
      <path d="M6,12 L9,15 L14,9" stroke-width="2.2"/>
    </g>

    <!-- trending up arrow -->
    <g transform="translate(195,235) rotate(-6)">
      <path d="M0,16 L8,8 L14,12 L22,2" stroke-width="2.2"/>
      <path d="M16,2 L22,2 L22,8"/>
    </g>

    <!-- diamond / premium -->
    <g transform="translate(55,155) rotate(10)">
      <path d="M10,0 L20,8 L10,20 L0,8 Z"/>
      <path d="M0,8 L20,8"/>
      <path d="M10,0 L7,8 L10,20"/>
      <path d="M10,0 L13,8 L10,20"/>
    </g>

    <!-- crown -->
    <g transform="translate(290,30) rotate(-10)">
      <path d="M0,16 L0,6 L6,10 L12,2 L18,10 L24,6 L24,16 Z" stroke-width="2"/>
      <line x1="0" y1="16" x2="24" y2="16" stroke-width="2.2"/>
    </g>

    <!-- calendar -->
    <g transform="translate(170,175) rotate(8)">
      <rect x="0" y="4" width="20" height="16" rx="3"/>
      <line x1="0" y1="9" x2="20" y2="9"/>
      <line x1="5" y1="0" x2="5" y2="6"/>
      <line x1="15" y1="0" x2="15" y2="6"/>
    </g>

    <!-- sparkle 1 -->
    <g transform="translate(118,130)">
      <path d="M5,0 C5.5,3 7,4 10,5 C7,6 5.5,8 5,11 C4.5,8 3,6 0,5 C3,4 4.5,3 5,0 Z" stroke-width="1.8"/>
    </g>

    <!-- sparkle 2 -->
    <g transform="translate(35,210) rotate(25)">
      <path d="M4,0 C4.5,2.5 6,3.5 8,4 C6,4.5 4.5,6 4,8 C3.5,6 2,4.5 0,4 C2,3.5 3.5,2.5 4,0 Z" stroke-width="1.8"/>
    </g>

    <!-- sparkle 3 -->
    <g transform="translate(285,135) rotate(-18)">
      <path d="M4,0 C4.5,2.5 6,3.5 8,4 C6,4.5 4.5,6 4,8 C3.5,6 2,4.5 0,4 C2,3.5 3.5,2.5 4,0 Z" stroke-width="1.8"/>
    </g>

    <!-- shopping bag -->
    <g transform="translate(10,270) rotate(5)">
      <rect x="0" y="6" width="18" height="16" rx="3"/>
      <path d="M4,6 C4,0 14,0 14,6"/>
    </g>

    <!-- laptop / tech -->
    <g transform="translate(240,105) rotate(-5)">
      <rect x="2" y="0" width="18" height="12" rx="2"/>
      <path d="M0,14 L22,14" stroke-width="2.2"/>
      <line x1="0" y1="12" x2="22" y2="12"/>
    </g>

    <!-- coin stack -->
    <g transform="translate(80,60) rotate(-10)">
      <ellipse cx="8" cy="14" rx="8" ry="3"/>
      <ellipse cx="8" cy="10" rx="8" ry="3"/>
      <ellipse cx="8" cy="6" rx="8" ry="3"/>
    </g>

  </g>
</svg>`);

export const useLandingPageStyles = () => {
  return {
    /* ── Left CTA: green gradient pill ── */
    primaryCta: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
      width: "100%",
      maxWidth: 420,
      padding: "16px 32px",
      background:
        "linear-gradient(135deg, #2e7d32 0%, #43a047 50%, #2e7d32 100%)",
      backgroundSize: "200% 200%",
      color: t.brand.white,
      fontSize: "16px",
      fontWeight: 600,
      letterSpacing: "0.3px",
      border: "none",
      borderRadius: t.radius.pill,
      cursor: "pointer",
      boxShadow: "0 4px 18px rgba(46,125,50,0.35), 0 1px 4px rgba(0,0,0,0.1)",
      transition: "all 0.3s ease",
      "&:hover": {
        backgroundPosition: "100% 0",
        boxShadow:
          "0 6px 24px rgba(46,125,50,0.45), 0 2px 6px rgba(0,0,0,0.12)",
        transform: "translateY(-2px)",
      },
      "&:active": {
        transform: "translateY(0)",
        boxShadow: "0 2px 10px rgba(46,125,50,0.3)",
      },
      "& svg": {
        fontSize: 20,
        transition: "transform 0.25s ease",
      },
      "&:hover svg": {
        transform: "translateX(4px)",
      },
    },

    /* ── Right CTA: glass outlined pill on green bg ── */
    secondaryCta: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      maxWidth: 400,
      padding: "16px 28px",
      background: "rgba(255,255,255,0.12)",
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
      color: t.brand.white,
      fontSize: "16px",
      fontWeight: 600,
      letterSpacing: "0.3px",
      border: "2px solid rgba(255,255,255,0.35)",
      borderRadius: t.radius.pill,
      cursor: "pointer",
      textDecoration: "none",
      boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
      transition: "all 0.3s ease",
      "&:hover": {
        background: "rgba(255,255,255,0.22)",
        borderColor: "rgba(255,255,255,0.55)",
        boxShadow: "0 6px 22px rgba(0,0,0,0.12)",
        transform: "translateY(-2px)",
      },
      "&:active": {
        transform: "translateY(0)",
        background: "rgba(255,255,255,0.18)",
      },
      "& svg": {
        fontSize: 20,
        transition: "transform 0.25s ease",
      },
      "&:hover svg": {
        transform: "translateX(4px)",
      },
    },

    buttonContainer1: {
      backgroundColor: "#2e7d32",
      color: t.brand.white,
      borderRadius: t.radius.sm,
      transition: t.transition.fast,
      "&:hover": {
        backgroundColor: "#256b29",
      },
    },
    middle: {
      fontSize: "17px",
      color: t.brand.white,
      textAlign: "center",
      marginBottom: "5%",
    },
    middle1: {
      fontSize: "16px",
      color: t.brand.white,
      textAlign: "center",
      marginBottom: "5%",
    },
    middle2: {
      fontSize: "15px",
      color: t.brand.white,
      textAlign: "center",
    },
    middlemobile: {
      fontSize: "12px",
      color: t.brand.white,
      textAlign: "center",
      marginBottom: "5%",
    },
    middle1mobile: {
      fontSize: "13px",
      color: t.brand.white,
      textAlign: "center",
      marginBottom: "5%",
    },
    middle2mobile: {
      fontSize: "15px",
      color: t.brand.white,
      textAlign: "center",
    },
    columnTwo: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "row",
      background:
        "linear-gradient(160deg, #00AEEF 0%, #0099D6 45%, #007ab8 100%)",
      color: t.brand.white,
      padding: "30px",
      position: "relative",
      overflow: "hidden",
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `url("data:image/svg+xml,${businessPatternSvg}")`,
        backgroundSize: "300px 300px",
        backgroundRepeat: "repeat",
        opacity: 1,
        pointerEvents: "none",
      },
    },
    heading: {
      color: t.brand.white,
      fontSize: "35px",
      fontWeight: "500",
      textAlign: "center",
    },
    Loginbutton: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      marginTop: "30px",
      "& a": {
        textDecoration: "none",
        width: "100%",
        maxWidth: 400,
      },
    },
    middleheading: {
      fontSize: "20px",
      textAlign: "center",
      marginBottom: "50px",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
    },
    middleheading1: {
      fontSize: "15px",
      textAlign: "center",
      marginBottom: "50px",
    },
    business: {
      marginTop: "5%",
      marginBottom: "20px",
      color: t.brand.white,
    },
    businessRow: {
      display: "flex",
      alignItems: "center",
      gap: "14px",
      marginTop: "5%",
      marginBottom: "20px",
    },
    businessIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 72,
      height: 72,
      borderRadius: "50%",
      background: "rgba(255,255,255,0.12)",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
      border: "2px solid rgba(255,255,255,0.25)",
      boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
      marginBottom: "12px",
      "& svg": {
        fontSize: 36,
        color: t.brand.white,
      },
    },
    columnOne: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "row",
      background: t.glass.primary,
      backdropFilter: t.blur.heavy,
      WebkitBackdropFilter: t.blur.heavy,
      color: t.text.primary,
      padding: "30px",
    },

    /* ── Vertical divider between panels ── */
    verticalDivider: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: 0,
      position: "relative",
      zIndex: 5,
    },
    dividerLine: {
      width: "2px",
      flex: 1,
      background:
        "linear-gradient(180deg, transparent 0%, rgba(0,174,239,0.35) 30%, rgba(0,174,239,0.5) 50%, rgba(0,174,239,0.35) 70%, transparent 100%)",
      borderRadius: "2px",
    },
    dividerBadge: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 44,
      height: 44,
      borderRadius: "50%",
      background: "linear-gradient(135deg, #f5a623 0%, #e8912d 100%)",
      color: t.brand.white,
      fontSize: "12px",
      fontWeight: 700,
      letterSpacing: "1px",
      boxShadow: "0 0 16px rgba(245,166,35,0.4), 0 2px 8px rgba(0,0,0,0.12)",
      border: "3px solid rgba(255,255,255,0.9)",
      flexShrink: 0,
    },
    columnTwodetail: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      maxWidth: 520,
      position: "relative",
      zIndex: 1,
    },
    "@media (max-width: 800px)": {
      columnTwo: {
        padding: "30px",
      },
      columnOne: {
        padding: "30px",
      },
      heading: {
        fontSize: "16px",
      },
    },
  };
};
